





















































import Vue from "vue";
import { UserGroup, UserGroupMember } from "@infoland/iprova-api";
import CardProperty from "./CardProperty.vue";

export default Vue.extend({
    name: "UserGroupCard",
    components: { CardProperty },
    props: {
        /** The user group represented by this card */
        userGroup: { type: Object as () => UserGroup, required: true }
    },
    data: function () {
        return {
            /** model for the tab view on the card */
            tab: null as number
        };
    },
    computed: {
        /** Gets the users of the group, sorted by name, alphabetically */
        sortedUsers(): UserGroupMember[] {
            const returnValue: UserGroupMember[] = this.userGroup.users ? [...this.userGroup.users] : [];
            return returnValue.sort((a, b) => {
                var textA: string = a.name.toUpperCase();
                var textB: string = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            });
        }
    },
    methods: {
        /** Closes the card by emiting 'close' */
        closeCard(): void {
            this.$emit("close");
        }
    }
});
